<script lang="ts">
</script>

<img src="/webdev.jpg" alt="Web Development" class="inverted-radius" />

<style>
	/** https://css-shape.com/inverted-radius **/
	/* HTML: <img class="inverted-radius" src="" alt=""> */
	.inverted-radius {
		--r: 20px; /* the radius */
		--s: 30px; /* size of inner curve */
		--x: 20px; /* horizontal offset (no percentage) */
		--y: 10px; /* vertical offset (no percentage) */

		width: 250px;
		aspect-ratio: 1;
		background: var(--background);
		border-radius: var(--r);
		--_m: /calc(2 * var(--r)) calc(2 * var(--r)) radial-gradient(#000 70%, #0000 72%);
		--_g: conic-gradient(at var(--r) var(--r), #000 75%, #0000 0);
		--_d: (var(--s) + var(--r));
		mask:
			calc(var(--_d) + var(--x)) 0 var(--_m),
			0 calc(var(--_d) + var(--y)) var(--_m),
			radial-gradient(var(--s) at 0 0, #0000 99%, #000 calc(100% + 1px)) calc(var(--r) + var(--x))
				calc(var(--r) + var(--y)),
			var(--_g) calc(var(--_d) + var(--x)) 0,
			var(--_g) 0 calc(var(--_d) + var(--y));
		mask-repeat: no-repeat;
	}
</style>
